module.exports = __webpack_public_path__ + "static/img/play.a73eacc2.png";